import { FaPenToSquare, FaEye } from "react-icons/fa6";

const InfoSummeryPost = ({ post }) => {
  return (
    <div className="grid sm:grid-cols-8 grid-cols-4 items-center py-3 px-4">
      <p className="col-span-4 sm:col-span-3 font-medium truncate">
        {post.title}
      </p>
      <p className="hidden sm:block col-span-1 text-center text-sm text-base-content/70 truncate">
        {post.posted_by_name}
      </p>
      <p className="hidden sm:block col-span-1 text-center text-sm text-base-content/70">
        {post.post_type}
      </p>
      <div className="hidden sm:flex col-span-1 justify-center">
        <span
          className={`badge badge-sm ${post.visible ? "badge-success" : "badge-ghost"}`}
        >
          {post.visible ? "Ja" : "Nej"}
        </span>
      </div>
      <div className="col-span-1 flex justify-center">
        <a href={`userprofile/editpost?slug=${post.slug}`}>
          <button className="btn btn-ghost btn-xs">
            <FaPenToSquare size={15} />
          </button>
        </a>
      </div>
      <div className="col-span-1 flex justify-center">
        <a href={`/music/${post.posted_by_slug}/blog/${post.slug}`}>
          <button className="btn btn-ghost btn-xs">
            <FaEye size={15} />
          </button>
        </a>
      </div>
    </div>
  );
};

export default InfoSummeryPost;
